var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('chart-bar-stacked',{ref:"barChart",attrs:{"options":_vm.timelogChartOptions,"chart-data":_vm.todayChartData}})}
var staticRenderFns = []

export { render, staticRenderFns }